import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip, Box, Typography, Container, IconButton, Avatar, AppBar, Toolbar, Button, useTheme, useMediaQuery } from '@mui/material';
import backgroundImage from '../Icon/Background2.png';
import Footer2 from './Footer2';
import Header from '../Header/Header';
import Header1 from '../Header/Header1';
import CertificateImage from '../Icon/Startup_India_Certificate.png';
import VisionBackground from '../Icon/Vission_latest.png';
import MissionBackground from '../Icon/mi1.png';
import Slider from 'react-slick';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import JourneyPage from '../Home/JourneyPage';
import { FaBrain, FaRobot, FaProjectDiagram } from 'react-icons/fa';
import { MdAssistant, MdDataUsage } from 'react-icons/md';
import { 
  AiOutlineCloud,
  AiOutlineMobile,
  AiOutlineApi,
} from 'react-icons/ai';
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Paper,
  Icon,
} from '@mui/material';
import {
  AiFillRobot,
  AiOutlineCode,
  AiOutlineGlobal,
  AiOutlineDeploymentUnit,
  AiOutlineBulb,
  AiOutlineFlag,
  AiOutlineSafety,
  AiOutlineUser,
  AiOutlineTeam,
  AiOutlineRocket,
  AiOutlineInfoCircle,
  AiOutlineTrophy,
} from 'react-icons/ai';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { styled } from '@mui/material/styles';
import { AiOutlineAim, AiOutlineEye } from 'react-icons/ai';
import Appointments from './Appointments';

const API_URL = process.env.REACT_APP_API_URL;

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  appendDots: dots => (
    <div
      style={{
        position: 'absolute',
        bottom: window.innerWidth < 600 ? '-20px' : window.innerWidth < 960 ? '-25px' : '-30px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ul style={{
        margin: '0px',
        padding: '0px',
        display: 'flex',
        gap: window.innerWidth < 600 ? '1px' : '5px' // Smaller gap for small screens
      }}>
        {dots}
      </ul>
    </div>
  ),

  customPaging: () => (
    <div
      style={{
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: 'white',
        opacity: 0.5,
      }}
    />
  )
};



function AboutUs({ userId, loggedIn, onLogout }) {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
  };

  const handleLogout = () => {
    onLogout(); // Call the passed logout function
    navigate('/login'); // Navigate to login page after logout
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const HoverableCardHeader = styled(CardHeader)(({ theme }) => ({
    transition: 'color 0.3s',
    '&:hover .MuiCardHeader-title': {
      color: '#1E90FF', // Change title color to blue on hover
    },
  }));



  const address = "No 26, Laskar Hosur Road, Adugodi, Bangalore South, Bengaluru, Karnataka 560030, India";

  const location = {
    lat: 12.936373,  // Latitude
    lng: 77.611114 // Longitude
  };

  const MAP_LIBRARIES = ['marker'];

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  const darkModeStyles = [
    {
      "elementType": "geometry",
      "stylers": [
        { "color": "#212121" }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        { "visibility": "off" }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        { "color": "#757575" }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        { "color": "#212121" }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        { "visibility": "off" }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
        { "color": "#262626" }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        { "color": "#212121" }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        { "color": "#000000" }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        { "color": "#2c2c2c" }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        { "color": "#8b8686" }
      ]
    },
  ];

  const options = {
    styles: darkModeStyles,
    disableDefaultUI: true, // Optional: Disable default UI
  };

  const mapContainerStyle = {
    width: '100%',
    height: '400px'
  };

  useEffect(() => {
    const checkGoogleMaps = () => {
      if (window.google && window.google.maps) {
        setMapLoaded(true);
      } else {
        console.error("Google Maps not loaded yet");
      }
    };

    window.addEventListener('load', checkGoogleMaps);

    return () => {
      window.removeEventListener('load', checkGoogleMaps);
    };
  }, []);

  const technologies = [
  {
    title: 'Artificial Intelligence',
    icon: <FaBrain size={40} color="#1E90FF" />,
    content: 'Building capable and safe AI models for real-world applications.',
  },
  {
    title: 'Machine Learning',
    icon: <AiOutlineBulb size={40} color="#1E90FF" />,
    content: 'Utilizing ML techniques to enhance user experience and deliver insights.',
  },
  {
    title: 'Natural Language Processing',
    icon: <AiOutlineGlobal size={40} color="#1E90FF" />,
    content: 'Researching advanced NLP methods to understand and generate human language.',
  },
  {
    title: 'Large Language Models (LLMs)',
    icon: <AiOutlineCode size={40} color="#1E90FF" />,
    content: 'Fine-tuning and building cutting-edge language models for diverse use cases.',
  },
  {
    title: 'AI Agents & Assistants',
    icon: <MdAssistant size={40} color="#1E90FF" />,
    content: 'Developing intelligent AI agents and virtual assistants for automation and support.',
  },
  {
    title: 'Deep Learning',
    icon: <FaRobot size={40} color="#1E90FF" />,
    content: 'Applying deep neural networks to solve complex problems efficiently.',
  },
  {
    title: 'Retrieval-Augmented Generation (RAG)',
    icon: <AiOutlineApi size={40} color="#1E90FF" />,
    content: 'Building hybrid models combining retrieval and generation techniques.',
  },
  {
    title: 'Data Science',
    icon: <MdDataUsage size={40} color="#1E90FF" />,
    content: 'Analyzing and interpreting complex data to optimize AI model performance.',
  },
 
  {
    title: 'AI Ethics & Safety',
    icon: <FaProjectDiagram size={40} color="#1E90FF" />,
    content: 'Ensuring responsible, ethical AI design and deployment.',
  },
];

  const values = [
    {
      title: 'Freedom',
      icon: <AiOutlineFlag size={40} />,
      description: 'The power to act, speak or think as one wants without hindrance or restraint.',
    },
    {
      title: 'Discipline',
      icon: <AiOutlineSafety size={40} />,
      description: 'The practice of following a standard code of behavior.',
    },
    {
      title: 'Equality',
      icon: <AiOutlineUser size={40} />,
      description: 'The state of being equal, especially in status, rights and opportunities.',
    },
  ];


  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);

    const handlePopState = (event) => {
      navigate('/home'); // If you want to navigate to home on back button press
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);


  return (
    <div>
      {loggedIn ? (
        <Header1 style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }} userId={userId} onLogout={onLogout} />
      ) : (
        <Header style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }} />
      )}
      {/* <Header1 /> */}
      {/* <Header1 userId={userId} onLogout={onLogout} />  */}
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          // backgroundImage: `url(${backgroundImage})`,
          backgroundColor: 'black',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          padding: '20px',
          marginTop: 10,
          paddingTop: '80px',
          paddingBottom: '100px',
        }}
      >
        <div
          style={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            padding: '0 20px', // Add horizontal padding
          }}
        >
          <Typography
            variant="h2"
            align="center"
            component="h1"
            sx={{
              fontFamily: 'Helvetica, sans-serif', // Changed to Helvetica
              fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' },
              letterSpacing: 10,
              '&:hover': {
                color: '#1E90FF', // Change font color to blue on hover
              }, // Responsive font sizes
            }}
          >
            About Us
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
  <Box
    sx={{
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      backdropFilter: 'blur(8px)',
      borderRadius: '20px',
      border: '1.5px solid rgba(255, 255, 255, 0.1)',
      width: '100%',
      maxWidth: '1200px',
      display: 'flex',
      flexDirection: isSmallScreen ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      px: 2,
      py: 3,
      gap: 1.5,
      boxShadow: '0 0 12px rgba(30,144,255,0.2)',
    }}
  >
    {[
      { label: 'Overview', id: 'overview' },
      { label: 'Mission & Vision', id: 'mission_and_vision' },
      { label: 'Team', id: 'team' },
      { label: 'Values', id: 'values' },
      { label: 'Technologies', id: 'technologies' },
      { label: 'Future Plans', id: 'future' },
      { label: 'Journey', id: 'journey' },
      { label: 'Location', id: 'location' },
      { label: 'Achievements', id: 'achievements' },
      { label: 'Appointments', id: 'appointments' },
    ].map((item, index) => (
      <Button
        key={index}
        onClick={() => scrollToSection(item.id)}
        variant="text"
        color="inherit"
        sx={{
          color: 'white',
          px: 3,
          py: 1,
          fontWeight: 500,
          fontSize: '0.95rem',
          letterSpacing: 3,
          textTransform: 'uppercase',
          borderRadius: '12px',
          transition: 'all 0.3s ease',
          '&:hover': {
            color: '#1E90FF',
            backgroundColor: 'rgba(30, 144, 255, 0.1)',
            borderColor: '#1E90FF',
            transform: 'translateY(-2px)',
          },
          border: '1px solid transparent',
          width: isSmallScreen ? '100%' : 'auto',
        }}
      >
        {item.label}
      </Button>
    ))}
  </Box>
</Box>


          <Container
  id="overview"
  maxWidth="lg"
  sx={{
    bgcolor: 'black',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    py: { xs: 6, md: 10 },
  }}
>
  <Typography
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 6,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: '#ffffff',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Overview
  </Typography>

  <Grid container justifyContent="center">
    <Grid item xs={12} sm={10} md={8}>
      <Card
        elevation={6}
        sx={{
          background: 'linear-gradient(145deg, #000000ff, #000000ff)',
          borderRadius: '16px',
          overflow: 'hidden',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pt: 4,
          }}
        >
          <AiOutlineInfoCircle size={60} style={{ color: '#1E90FF' }} />
        </Box>

        <CardContent sx={{ px: 5, py: 4 }}>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 600,
              letterSpacing: 4,
              color: '#ffffff',
              mb: 3,
              '&:hover': {
                color: '#1E90FF',
              },
            }}
          >
            Unlocking Knowledge for All
          </Typography>

          <Typography
            variant="body1"
            align="center"
            sx={{
              color: '#cfcfcf',
              lineHeight: 1.8,
              letterSpacing: 1,
              whiteSpace: 'pre-line',
            }}
          >
            Anthrasync is an AI startup on a mission to make all valuable information and knowledge universally accessible.
            {'\n\n'}
            We envision a world where language is no longer a barrier, and where the flow of trusted insights is seamless — across borders, cultures, and communities.
            {'\n\n'}
            We’re building a real-time knowledge exchange platform that empowers anyone, anywhere, to access, share, and engage with valuable information — regardless of their language, background, or location.
            {'\n\n'}
            The platform is inclusive of all knowledge domains, from science and technology to arts, humanities, business, health, and beyond — enabling a truly comprehensive exchange of ideas.
            {'\n\n'}
            In addition to the platform, we are developing state-of-the-art AI Agents and Assistants tailored for real-world use cases — from personalized learning and multilingual communication to enterprise intelligence and global collaboration.
            {'\n\n'}
            At Anthrasync, we believe that everyone deserves access to high-quality, meaningful information — and that AI can make it happen.
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Container>


         <Container
  id="mission_and_vision"
  sx={{
    my: { xs: 10, sm: 12, md: 14 },
    maxWidth: '1000px',
    margin: '0 auto',
    px: { xs: 2, sm: 4, md: 6 },
  }}
>
  <Typography
    variant="h4"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 6,
      fontWeight: '700',
      mb: 6,
      color: 'white',
      textTransform: 'uppercase',
      position: 'relative',
      '&:hover': {
        color: '#1E90FF',
      },
      '&::after': {
        content: '""',
        display: 'block',
        width: 60,
        height: 4,
        bgcolor: '#1E90FF',
        borderRadius: 2,
        margin: '12px auto 0',
      },
    }}
  >
    Mission & Vision
  </Typography>

  <Grid container spacing={6} justifyContent="center" alignItems="stretch">
    {[
      {
        title: 'Mission',
        text: 'To provide a platform for every individual to access and share all kinds of knowledge.',
        icon: <AiOutlineAim size={50} color="#1E90FF" />,
      },
      {
        title: 'Vision',
        text: 'To make every kind of knowledge accessible for everyone.',
        icon: <AiOutlineEye size={50} color="#1E90FF" />,
      },
    ].map((item, index) => (
      <Grid item xs={12} md={6} key={index}>
        <Box
          sx={{
            position: 'relative',
            background: 'rgba(30, 144, 255, 0.1)',
            borderRadius: '20px',
            padding: { xs: 4, sm: 6 },
            boxShadow: '0 8px 32px 0 rgba(30, 144, 255, 0.2)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            textAlign: 'center',
            height: '100%',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            cursor: 'default',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            '&:hover': {
              transform: 'translateY(-10px)',
              boxShadow: '0 12px 40px 0 rgba(30, 144, 255, 0.5)',
            },
          }}
        >
          <Box
            sx={{
              mb: 3,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {item.icon}
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              letterSpacing: 6,
              fontSize: { xs: '1.8rem', sm: '2.2rem' },
              mb: 3,
              textTransform: 'uppercase',
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                bottom: -10,
                width: 50,
                height: 3,
                bgcolor: '#1E90FF',
                borderRadius: 2,
              },
            }}
          >
            {item.title}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontStyle: 'italic',
              fontSize: { xs: '1rem', sm: '1.1rem' },
              letterSpacing: 1.8,
              lineHeight: 1.7,
              maxWidth: '90%',
              mx: 'auto',
              color: 'rgba(255, 255, 255, 0.85)',
            }}
          >
            &quot;{item.text}&quot;
          </Typography>
        </Box>
      </Grid>
    ))}
  </Grid>
</Container>



          <Container
  id="team"
  maxWidth="lg"
  sx={{
    bgcolor: 'black',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    py: { xs: 6, md: 10 },
    mb: 15,
  }}
>
  <Typography
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 6,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: '#ffffff',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Our Team
  </Typography>

  <Grid container justifyContent="center">
    <Grid item xs={12} sm={10} md={8}>
      <Card
        elevation={6}
        sx={{
          background: 'linear-gradient(145deg, #000000ff, #000000ff)',
          borderRadius: '16px',
          overflow: 'hidden',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pt: 4,
          }}
        >
          <AiOutlineTeam size={60} style={{ color: '#1E90FF' }} />
        </Box>

        <CardContent sx={{ px: 5, py: 4 }}>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 600,
              letterSpacing: 4,
              color: '#ffffff',
              mb: 3,
              '&:hover': {
                color: '#1E90FF',
              },
            }}
          >
            Passionate & Dedicated
          </Typography>

          <Typography
            variant="body1"
            align="center"
            sx={{
              color: '#cfcfcf',
              lineHeight: 1.8,
              letterSpacing: 1,
            }}
          >
            Our team at Anthrasync consists of highly passionate, dedicated and motivated individuals who are continuously working towards one common goal. 
            We are always willing to take risks, face challenges and overcome them. We make sure that we are regularly updating our skills and are part of a continuous process of learning and growth.
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Container>
          <Container
  id="values"
  maxWidth="lg"
  sx={{
    bgcolor: '#000000',
    minHeight: '60vh',
    color: 'white',
    py: { xs: 6, md: 10 },
    mb: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // ✅ Center content horizontally
  }}
>
  <Typography
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 5,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: '#ffffff',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Our Core Values
  </Typography>

  <Grid container spacing={4} justifyContent="center">
    {values.map((value, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Card
          elevation={6}
          sx={{
            background: 'linear-gradient(145deg, #000000ff, #000000ff)',
            borderRadius: '16px',
            overflow: 'hidden',
            height: '100%',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center', // ✅ Center text inside card
            '&:hover': {
              transform: 'translateY(-6px)',
              boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
            },
          }}
        >
          <Box sx={{ pt: 4 }}>
            <Avatar sx={{ backgroundColor: 'transparent', color: '#1E90FF', width: 56, height: 56 }}>
              {value.icon}
            </Avatar>
          </Box>

          <CardContent sx={{ px: 4, py: 3 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: '#ffffff',
                fontWeight: 600,
                letterSpacing: 2,
                '&:hover': {
                  color: '#1E90FF',
                },
              }}
            >
              {value.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#cfcfcf',
                letterSpacing: 1,
                lineHeight: 1.7,
              }}
            >
              {value.description}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
</Container>


          <Container
  id="technologies"
  maxWidth="lg"
  sx={{
    bgcolor: '#000000',
    color: 'white',
    py: { xs: 6, md: 10 },
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // ✅ center-align content
  }}
>
  <Typography
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 5,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: 'white',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Technologies We Deal With
  </Typography>

  <Grid container spacing={4} justifyContent="center">
    {technologies.map((tech, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Card
          elevation={6}
          sx={{
            background: 'linear-gradient(145deg, #000000ff, #000000ff)',
            borderRadius: '16px',
            overflow: 'hidden',
            height: '100%',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            '&:hover': {
              transform: 'translateY(-6px)',
              boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
            },
          }}
        >
          <Box sx={{ pt: 4 }}>
            <Avatar sx={{ backgroundColor: 'transparent', color: '#1E90FF', width: 56, height: 56 }}>
              {tech.icon}
            </Avatar>
          </Box>

          <CardContent sx={{ px: 4, py: 3 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: 'white',
                fontWeight: 600,
                letterSpacing: 2,
                '&:hover': {
                  color: '#1E90FF',
                },
              }}
            >
              {tech.title}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: '#cfcfcf',
                letterSpacing: 1,
                lineHeight: 1.7,
              }}
            >
              {tech.content}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
</Container>


<Container
  id="future"
  maxWidth="lg"
  sx={{
    bgcolor: 'black',
    color: 'white',
    py: { xs: 6, md: 10 },
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mx: 'auto',
    mb: 15,
  }}
>
  <Typography
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 5,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: 'white',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Future Plans
  </Typography>

  <Grid container justifyContent="center">
    <Grid item xs={12} sm={10} md={8}>
      <Card
        elevation={6}
        sx={{
          background: 'linear-gradient(145deg, #000000ff, #000000ff)',
          borderRadius: '16px',
          overflow: 'hidden',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
          },
        }}
      >
        <Box sx={{ pt: 4 }}>
          <AiOutlineRocket size={60} style={{ color: '#1E90FF' }} />
        </Box>

        <CardContent sx={{ px: 5, py: 4 }}>
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              fontWeight: 600,
              letterSpacing: 3,
              color: 'white',
              '&:hover': {
                color: '#1E90FF',
              },
            }}
          >
            Continuous Upgradation
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#cfcfcf',
              letterSpacing: 1,
              lineHeight: 1.8,
              mb: 3,
            }}
          >
            In the upcoming months, we will be adding new features and continuously upgrading the platform to enhance user experience and performance. Our team is committed to delivering regular improvements, ensuring that you have access to the latest tools and functionalities. Stay tuned as we work to make the platform even more powerful and user-friendly, meeting your evolving needs.
          </Typography>

          <Divider sx={{ my: 2, bgcolor: 'grey.700', mx: 'auto', width: '80%' }} />

          <Typography
            variant="body2"
            sx={{
              color: '#cfcfcf',
              letterSpacing: 1,
            }}
          >
            Stay tuned for updates as we move forward with this exciting journey!
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Container>
          <Box id="journey">
            <JourneyPage />

          </Box>


          <Box
  id="location"
  sx={{
    backgroundColor: '#000000',
    color: 'white',
    mt: 15,
    py: { xs: 6, md: 10 },
    px: { xs: 3, md: 6 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // ✅ center-align everything
  }}
>
  <Typography
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 5,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Our Location
  </Typography>

  <Grid container spacing={4} justifyContent="center">
    <Grid item xs={12} md={6}>
      <Box
        sx={{
          background: 'linear-gradient(145deg, #000000ff, #000000ff)',
          borderRadius: '16px',
          padding: 4,
          textAlign: 'center',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
          },
        }}
      >
        <LocationOnIcon sx={{ fontSize: 50, color: '#1E90FF' }} />
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontWeight: 600,
            color: 'white',
            letterSpacing: 3,
            '&:hover': {
              color: '#1E90FF',
            },
          }}
        >
          Registered Address
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            color: '#cfcfcf',
            letterSpacing: 2,
            lineHeight: 1.6,
          }}
        >
          {address}
        </Typography>
      </Box>
    </Grid>

    <Grid item xs={12} md={6}>
      <Box sx={{ height: 300, borderRadius: 2, overflow: 'hidden' }}>
        <LoadScript
          googleMapsApiKey="AIzaSyASEtkoHNy8SPOS-4KBOH7QzCuBdSa8P_A"
          onError={() => console.error('Error loading Google Maps')}
        >
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={location}
            zoom={15}
            options={options}
          >
            <Marker position={location} />
          </GoogleMap>
        </LoadScript>
      </Box>
    </Grid>
  </Grid>
</Box>

          <Container
  id="achievements"
  maxWidth="lg"
  sx={{
    bgcolor: 'black',
    color: 'white',
    py: { xs: 6, md: 10 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mb: 15,
  }}
>
  <Typography
    variant="h3"
    align="center"
    gutterBottom
    sx={{
      letterSpacing: 5,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      position: 'relative',
      display: 'inline-block',
      mb: 6,
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '60%',
        height: '4px',
        bottom: -8,
        left: '20%',
        background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
        borderRadius: 2,
      },
      '&:hover': {
        color: '#1E90FF',
      },
    }}
  >
    Achievements
  </Typography>

  <Grid container spacing={4} justifyContent="center">
    <Grid item xs={12} sm={10} md={6}>
      <Box
        sx={{
          background: 'linear-gradient(145deg, #000000ff, #000000ff)',
          color: 'white',
          borderRadius: '16px',
          border: '2px solid transparent',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
          '&:hover': {
            transform: 'translateY(-6px)',
            borderColor: '#1E90FF',
            boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
          },
        }}
      >
        <CardContent sx={{ textAlign: 'center', px: 4, py: 5 }}>
          <Box sx={{ mb: 2 }}>
            <AiOutlineTrophy size={60} style={{ color: '#1E90FF' }} />
          </Box>

          <Typography
            variant="h5"
            sx={{
              letterSpacing: 3,
              fontWeight: 600,
              '&:hover': {
                color: '#1E90FF',
              },
            }}
          >
            Certificate of Recognition
          </Typography>

          <Divider sx={{ my: 3, bgcolor: 'grey.700', mx: 'auto', width: '80%' }} />

          <Box
            sx={{
              display: 'inline-block',
              borderRadius: '10px',
              overflow: 'hidden',
              border: '2px solid transparent',
              transition: 'border-color 0.4s ease-in-out',
              '&:hover': {
                borderColor: '#1E90FF',
              },
            }}
          >
            <img
              src={CertificateImage}
              alt="Startup India Certificate"
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '10px',
                boxShadow: 'rgba(30, 144, 255, 0.4) 0px 4px 10px',
              }}
            />
          </Box>

          <Box sx={{ mt: 4, textAlign: 'left' }}>
            <Typography variant="body2" sx={{ color: '#cfcfcf', letterSpacing: 2 }}>
              <strong>Issued by:</strong> DPIIT
            </Typography>
            <Typography variant="body2" sx={{ color: '#cfcfcf', letterSpacing: 2 }}>
              <strong>Date:</strong> August 17, 2024
            </Typography>
          </Box>
        </CardContent>
      </Box>
    </Grid>
  </Grid>
</Container>

<Container
  id="appointments"
  maxWidth="lg"
  sx={{
    bgcolor: 'black',
    color: 'white',
    py: { xs: 6, md: 10 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mb: 15,
  }}
>
  <Appointments/>
</Container>




          <style>
            {`
              @keyframes curveMove {
                0% {
                  transform: scale(1) translateY(0px);
                }
                50% {
                  transform: scale(1.05) translateY(-10px) translateX(10px);
                }
                100% {
                  transform: scale(1) translateY(0px);
                }
              }
            `}
          </style>

          <Box sx={{ margin: '40px 0' }} /> {/* Spacer Box */}
        </div>
      </div>

      <Tooltip title="Scroll to Top" placement="top">

        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black', "&:hover": {
              color: "#1E90FF",  // Icon color on hover
            },
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
      </Tooltip>
      <Footer2 />
    </div>
  );
}

export default AboutUs;
